import React from 'react';
import { Container, Row, Col } from '../../../../grid';
import Serena from '../../../../Serena';
import { Paragraph } from '../../../../typography';

const RenderProductPageXtraDescription = ({
  productPageXtraDescription,
  serena,
}) => {
  if (serena) {
    return (
      <React.Fragment>
        <Container white mb>
          <Row paddingTop>
            <Col xs={12}>
              <Serena />
            </Col>
          </Row>
        </Container>
        <Container white mb>
          <Row paddingTop>
            <Col xs={12}>
              <Paragraph>
                {productPageXtraDescription()}
              </Paragraph>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
  if (productPageXtraDescription) {
    return (
      <Container white mb>
        <Row paddingTop>
          <Col xs={12}>
            {productPageXtraDescription()}
          </Col>
        </Row>
      </Container>
    );
  }
  return null;
};

// Export
export default RenderProductPageXtraDescription;
